import { Component, Input, OnInit } from "@angular/core";
import {
  ComponentMediaViewModel,
  IComponentMediaViewModel,
  MediaCategoryTypeNameEnum,
  MediaTypeNameEnum,
  SectionTypeNameEnum,
  SectionViewModel,
} from "src/domain/client";
import { ModelAndDealerService } from "src/services/model-and-dealer.service";
import { ThemeService } from "src/services/theme.service";

type LayerListEntry =
  | ComponentMediaViewModel
  | (Omit<IComponentMediaViewModel, "url"> & { url: string | string[] });

@Component({
  selector: "vw-footer",
  templateUrl: "./footer.component.html",
})
export class FooterComponent implements OnInit {
  @Input() footerSection?: SectionViewModel;

  layerOne: LayerListEntry[] = [];
  layerTwo: LayerListEntry[] = [];
  layerThree: LayerListEntry[] = [];

  private cookieLink: LayerListEntry;

  constructor(
    public modelAndDealerService: ModelAndDealerService,
    private themeService: ThemeService,
  ) {
    this.cookieLink = {
      mediaTypeName: MediaTypeNameEnum.Link,
      mediaCategoryTypeName: MediaCategoryTypeNameEnum.HREF,
      layer: "1",
      displayName: "Cookies",
      url: ["/", themeService.brand || "", "cookies"],
    };
    this.layerOne.push(this.cookieLink);
  }

  ngOnInit(): void {
    if (this.footerSection != null) this.setFooterLinks(this.footerSection);
  }

  isArray(o: unknown): o is readonly unknown[] {
    return Array.isArray(o);
  }

  //////////

  private setFooterLinks(footerSection: SectionViewModel): void {
    footerSection.components?.forEach((component) => {
      component.media?.forEach((media) => {
        if (media.url && media.url.includes("{brand}")) {
          media.url = media.url.replace(
            "{brand}",
            this.themeService.brand || "",
          );
        }
      });
    });

    const footerLinks: LayerListEntry[] | undefined = footerSection.components
      ?.find((_) => _.technicalName === SectionTypeNameEnum.Footer)
      ?.media?.filter(
        (_) =>
          _.mediaTypeName === MediaTypeNameEnum.Link &&
          _.mediaCategoryTypeName === MediaCategoryTypeNameEnum.HREF,
      );

    if (footerLinks) {
      this.layerOne = footerLinks.filter((_) => _.layer === "1");
      this.layerOne.push(this.cookieLink);
      this.layerTwo = footerLinks.filter((_) => _.layer === "2");
      this.layerThree = footerLinks.filter((_) => _.layer === "3");
    }
  }
}
